import styled, { css } from 'styled-components';
import competitorsTileSmall from 'images/competitorsTileSmall.png';
import competitorsTileLarge from 'images/competitorsTileLarge.png';
import subscriptionsTileSmall from 'images/subscriptionsTileSmall.png';
import subscriptionsTileLarge from 'images/subscriptionsTileLarge.png';
import SparkleIconSvg from 'images/icons/personalize.svg';
import { absFull } from 'helpers/styles.js';

export const AddEntitiesContainer = styled.div`
  position: relative;
  height: 0;
  overflow: hidden;
  margin-bottom: 40px;
  transition: all .3s ease;
  ${({ open }) => open && css`
    height: 320px;
  `}
`;

export const TileContainer = styled.div`
  background: linear-gradient(173.75deg, #446D93 2.34%, #122333 97.44%);
  height: 260px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  padding: 64px 55px;
  position: relative;
  display: inline-block;

  ${({ half }) => half && css`
    width: 49%;

    &:first-child {
      margin-right: 1%;
    }

    &:last-child {
      margin-left: 1%;
    }
  `}

  &:after {
    content: '';
    ${absFull()};
    z-index: 1;
    background: linear-gradient(347.22deg,
      rgba(18, 35, 51, 0.78) -4.22%,
      rgba(29, 54, 77, 0.1) 41.23%,
      rgba(43, 79, 112, 0) 112.02%,
      rgba(43, 79, 112, 0) 112.02%);
  }

  @media (max-width: 1100px) {
    padding: 64px 24px;
  }
`;

export const TileTitle = styled.div`
  font-weight: bold;
  font-size: 10px;
  line-height: 18px;
  align-items: left;
  letter-spacing: 0.285em;
  text-transform: uppercase;
  color: #FFFFFF;
  margin-bottom: 12px;
  width: 50%;
`;

export const TileText = styled.div`
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #B3CDE4;
  width: 50%;
  margin: 12px 0 24px;
  max-width: 290px;
`;

export const AddCompetitorsSmall = styled.div`
  position: absolute;
  top: 44px;
  left: 60%;
  width: 70%;
  height: 100%;
  background: url('${competitorsTileSmall}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;

export const SparkleIcon = styled.div`
  width: 18px;
  height: 18px;
  position: relative;
  top: 6px;
  background: url('${SparkleIconSvg}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: inline-block;
  margin-right: 8px;
`;

export const PersonalizeText = styled.div`
  color: ${({ theme }) => theme.colors.palette[7]};
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 1px;
  margin-bottom: 24px;
`;


export const AddCompetitorsLarge = styled.div`
  position: absolute;
  top: 44px;
  left: 45%;
  width: 50%;
  height: 100%;
  background: url('${competitorsTileLarge}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;

export const AddSubscriptionsSmall = styled.div`
  position: absolute;
  top: 44px;
  left: 60%;
  width: 70%;
  height: 100%;
  background: url('${subscriptionsTileSmall}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;

export const AddSubscriptionsLarge = styled.div`
  position: absolute;
  top: 44px;
  left: 45%;
  width: 50%;
  height: 100%;
  background: url('${subscriptionsTileLarge}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;

export const GoButton = styled.div`
  position: relative;
  background: #2D8BFF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: 77px;
  height: 28px;
  line-height: 28px;
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 9px;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  cursor: pointer;
  transition: all .3s ease;
  z-index: 2;

  &:hover {
    transform: translateY(-1px);
  }

  &:after {
    content: 'GO';
  }
`;
